import styled from 'styled-components';
import ArticleCard from '../ArticleCard';

const ArtsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, 15vh);
    background: #9AA8B1;
    font-family: 'Oswald', sans-serif;
    font-weight: 700;
    font-size: 48px;
    border: 1px solid black;
    line-height: 13vh;

    .O1, .P, .I1, .N1, .I2, .O2, .N2, .Blank1 {
        border: inherit;
    }

    .O1 { grid-row: 1; grid-column: 1; }
    .P { grid-row: 1; grid-column: 2; }
    .I1 { grid-row: 1; grid-column: 3; }
    .N1 { grid-row: 2; grid-column: 1; border-bottom: 0px solid black;}
    .I2 { grid-row: 2; grid-column: 2; border-bottom: 0px solid black;}
    .O2 { grid-row: 2; grid-column: 3; border-bottom: 0px solid black;}
    .N2 { grid-row: 2; grid-column: 4; border-bottom: 0px solid black; }
    .Blank1 { grid-row: 1; grid-column: 4; }
`;

const ArticleGrid = styled.div`
    background: #9AA8B1;
    display: grid;
    grid-template-columns: 1fr;
`;

const ArtsMobile = ({ arts }) => {
    return (
        <>
            <ArtsGrid>
                <div className="O1">A</div>
                <div className="P">R</div>
                <div className="I1"></div>
                <div className="N1"></div>
                <div className="I2"></div>
                <div className="O2">T</div>
                <div className="N2">S</div>
                <div className="Blank1"></div>
            </ArtsGrid>
            <ArticleGrid>
                {arts.map((article, index) => (
                    <ArticleCard
                        key={index}
                        position={index % 2 === 0 ? 'left' : 'right'}
                        article_title={article.article_title}
                        article_byline={article.article_byline}
                        article_image={article.article_image}
                        article_url={article.article_url}
                    />
                ))}
            </ArticleGrid>
        </>
    );
};

export default ArtsMobile;
